import { useMemo } from 'react';
import { toBehaviorError } from '../../../../utils/behaviorErrorHandler';
import { nativeBehaviorEvaluator } from '../../../../nativeBehaviors/nativeBehaviorEvaluator';
import { configBehaviorsFunc } from '../../../../nativeBehaviors/configBehaviors';
import store from '../../../../reducers/storeRegistration';

/**
 * Native behavior plumbing for TVC issues `evaluateSource`.
 * Do not close over `active` in `evaluator`: it changes on every Redux content update and would
 * recreate this object → load effect re-runs while the same project is selected → evaluate/save
 * loop. Read `latestActive` from the store inside `evaluator` instead.
 */
const useTvcIssuesNativeFunctions = (reduxEntity, notificationActions) => useMemo(() => ({
  errorHandler: err => {
    const msg = typeof (err === null || err === void 0 ? void 0 : err.message) === 'string' && err.message.trim().length > 0 ? err.message.trim() : 'Failed to load TVC issues.';
    notificationActions === null || notificationActions === void 0 || notificationActions.info({
      headerMessage: 'Error',
      message: msg,
      id: 'tvc-issues-behavior-error'
    }, {
      autoClose: 5000
    });
    throw toBehaviorError(err, 'TVC issues behavior error');
  },
  evaluator: (source, evalContent, evalParentContentPath, transientContext, nf, callback, sourceEvaluator) => {
    var _store$getState$redux;
    const latestActive = (_store$getState$redux = store.getState()[reduxEntity]) === null || _store$getState$redux === void 0 ? void 0 : _store$getState$redux.active;
    if (latestActive == null) {
      callback(new Error('TVC issues: no active entity'));
      return undefined;
    }
    return nativeBehaviorEvaluator(latestActive, reduxEntity, source, evalContent, evalParentContentPath, transientContext, nf, callback, sourceEvaluator);
  },
  configBehaviors: configBehaviorsFunc
}), [reduxEntity, notificationActions]);
export default useTvcIssuesNativeFunctions;